<div class="app" [attr.data-state]="isAuthenticated ? 'authenticated' : 'loading'">
  <div class="authenticated-container" *ngIf="isAuthenticated && currentProduct">
    <header class="topbar">
      <h4></h4>
      <button class="btn" (click)="logout()">Sign out</button>
    </header>
    <main class="content">
      <app-operations-index 
        [currentProduct]="currentProduct" 
        [allProducts]="allProducts"
        [commonTools]="commonTools">
      </app-operations-index>
    </main>
  </div>

  <div class="loading-container" *ngIf="!isAuthenticated">
    <p class="loading-text">Loading...</p>
  </div>
</div>
